import { useTranslation } from "react-i18next";
import useSettings from "./useSettings";
import httpRequest from "../axios/index";
import { toast } from "react-hot-toast";

// config
import { defaultLang } from "../config";
import { useEffect } from "react";
import { useDispatch, useSelector } from "../redux/store";
import { setAllLangs } from "../redux/slices/Languages/LanguagesSlice";
import i18nForComponent from "../locales/component/i18nForComponent";

// hook for translation

export default function useLocales() {
  const { allLangs = [] } = useSelector((state) => state?.language);
  const dispatch = useDispatch();

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const languagesShow = async () => {
    if (!user?.userid) {
      if (allLangs.length === 0) {
        dispatch(setAllLangs({ addedLanguages: [] }));
      }
      return null;
    }
    try {
      const url = `/api/user/languages/${user?.userid}`;
      const response = await httpRequest.get(url);
      const resultLanguage = response?.data?.data || [];
      const status = response?.data?.status;

      if (status === "success") {
        dispatch(setAllLangs({ addedLanguages: resultLanguage }));
      }
    } catch (error) {
      // if (error?.response?.data?.status === "failed") {
      //   toast.error(error?.response?.data?.message);
      // } else {
      //   toast.error("Something went wrong");
      // }
      console.log(error)
    }
  };

  useEffect(() => {
    languagesShow();
  }, []);

  const { i18n, t: translate } = useTranslation();

  const { t: tComponent } = useTranslation("translations", {
    i18n: i18nForComponent,
  });

  const { onChangeDirectionByLang } = useSettings();

  const langStorage = localStorage.getItem("i18nextLng");

  const currentLang =
    allLangs?.find((_lang) => _lang.value === langStorage) || defaultLang;

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
    onChangeDirectionByLang(newlang);
  };

  const handleLanguageChange = (newlang) => {
    i18nForComponent.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    handleLanguageChange,
    translate: (text, options) => translate(text, options),
    tComponent,
    currentLang,
    allLangs,
  };
}
